import { SupportedCountryAbbreviation } from '@xbcb/shared-types';

export const euCountries = [
  SupportedCountryAbbreviation.UK,
  SupportedCountryAbbreviation.DE,
  SupportedCountryAbbreviation.FR,
  SupportedCountryAbbreviation.GB,
  SupportedCountryAbbreviation.NL,
];
